import moment from "moment";
import React, { useEffect, useState } from "react";
import { Badge, Button, Pagination, Table, TextInput } from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import { LuFilter, LuFilterX } from "react-icons/lu";
import axios from "../../config/axiosInstance";
import { useQuery } from "react-query";
import { ADMIN } from "../../config/apiConfig";
import EmptyTable from "./EmptyTable";
import TableLoading from "../TableLoading";

const AdminLoginAttemptsTable = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const onPageChange = (page) => setCurrentPage(page);
  const [startDatePeriod, setStartDatePeriod] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [endDatePeriod, setEndDatePeriod] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [startDate, setStartDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [email, setEmail] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [showFilters, setShowFilters] = useState(true);
  const [filtersApplied, setFiltersApplied] = useState(true);

  const {
    isLoadingListAttempts,
    error: errorListAttempts,
    data: listAttempts,
  } = useQuery(
    [
      "listLoginAttempts",
      currentPage,
      startDatePeriod,
      endDatePeriod,
      emailFilter,
    ],
    async () => {
      const queryEmail = emailFilter
        ? `&email=${encodeURIComponent(emailFilter)}`
        : "";
      const { data } = await axios.get(
        `${ADMIN.GET_LOGIN_ATTEMPTS}?page=${currentPage}&startDate=${startDatePeriod}&endDate=${endDatePeriod}${queryEmail}`
      );

      setTotalPages(data.data.totalPages || 1);
      setTotalCount(data.data.totalCount || 0);

      return data.data.data;
    }
  );

  const onClickSearchPeriod = () => {
    setStartDatePeriod(startDate);
    setEndDatePeriod(endDate);
    setEmailFilter(email.trim());
    setFiltersApplied(true);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [startDatePeriod, endDatePeriod, emailFilter]);

  return (
    <>
      <div className="flex justify-between items-center mb-2">
        <Button
          size="xs"
          onClick={() => setShowFilters((prev) => !prev)}
          className="bg-white text-slate-700 border border-slate-200 shadow-sm hover:bg-gray-50 hover:text-white transition-all duration-300"
        >
          <div className="flex items-center gap-2 transition-all duration-300">
            <span>{showFilters ? "Esconder filtros" : "Mostrar filtros"}</span>
            <span className="transition-transform duration-300">
              {!showFilters ? <LuFilter /> : <LuFilterX />}
            </span>
          </div>
        </Button>
      </div>
      <div className="flex flex-col gap-4">
        {showFilters && (
          <div className="bg-white border border-slate-200 rounded-xl shadow-sm transition-all duration-500 ease-in-out overflow-hidden">
            <div className="flex items-center justify-between gap-3 px-3 py-2 border-b border-slate-200 bg-gray-50 overflow-hidden">
              <div className="flex items-center gap-2">
                <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  Filtros Avançados
                </span>
                {!filtersApplied && (
                  <span className="text-[10px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-2 py-0.5">
                    Alterações pendentes
                  </span>
                )}
              </div>
              <Button
                size="xs"
                color="success"
                onClick={onClickSearchPeriod}
                disabled={filtersApplied}
              >
                Aplicar filtros
              </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-6 gap-3 px-3 py-3">
              <div className="flex flex-col md:col-span-2">
                <label className="text-[10px] font-semibold uppercase tracking-wide text-slate-500 mb-1">
                  Período inicial
                </label>
                <div className="h-9">
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                      setFiltersApplied(false);
                      if (moment(e.target.value).isAfter(moment(endDate))) {
                        setEndDate(e.target.value);
                      }
                    }}
                    className="w-full h-9 block px-2 rounded-md text-sm text-gray-600 bg-gray-100 border-0 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200"
                  />
                </div>
              </div>
              <div className="flex flex-col md:col-span-2">
                <label className="text-[10px] font-semibold uppercase tracking-wide text-slate-500 mb-1">
                  Período final
                </label>
                <div className="h-9">
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => {
                      setEndDate(e.target.value);
                      setFiltersApplied(false);
                    }}
                    min={startDate}
                    className="w-full h-9 block px-2 rounded-md text-sm text-gray-600 bg-gray-100 border-0 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200"
                  />
                </div>
              </div>
              <div className="flex flex-col md:col-span-2">
                <label className="text-[10px] font-semibold uppercase tracking-wide text-slate-500 mb-1">
                  E-mail
                </label>
                <div className="h-9">
                  <TextInput
                    type="text"
                    placeholder="E-mail"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setFiltersApplied(false);
                    }}
                    className="w-full"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="mt-3 text-sm md:text-sm italic">
        Informações baseadas no período selecionado{" "}
        <Badge className="w-fit inline" color="info">
          {moment(startDatePeriod).format("DD/MM/YYYY")}
        </Badge>{" "}
        -{" "}
        <Badge className="w-fit inline" color="info">
          {moment(endDatePeriod).format("DD/MM/YYYY")}
        </Badge>
        {emailFilter && (
          <Badge className="w-fit inline ml-2" color="info">
            {emailFilter}
          </Badge>
        )}
      </div>

      {listAttempts?.length > 0 || isLoadingListAttempts ? (
        <>
          <div className="overflow-x-auto bg-white rounded-xl border border-gray-200 shadow-sm mt-0 md:mt-5">
            <Table striped>
              <Table.Head>
                <Table.HeadCell className="text-center bg-gray-100">
                  IP
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-100">
                  E-mail
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-100">
                  Data/Hora
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-100">
                  Status
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-100">
                  Razão
                </Table.HeadCell>
              </Table.Head>

              <Table.Body className="divide-y">
                {!isLoadingListAttempts ? (
                  <>
                    {listAttempts?.length > 0 && (
                      <>
                        {listAttempts.map((attempt) => (
                          <Table.Row
                            key={attempt.id}
                            className="bg-white dark:border-gray-700 dark:bg-gray-800"
                          >
                            <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                              {attempt.ip || "—"}
                            </Table.Cell>
                            <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                              {attempt.email || attempt?.User?.email || "—"}
                            </Table.Cell>
                            <Table.Cell className="text-center py-2">
                              {moment(attempt.createdAt).format(
                                "DD/MM/YYYY - HH:mm"
                              )}
                            </Table.Cell>
                            <Table.Cell className="text-center py-2">
                              {attempt.success ? (
                                <Badge
                                  color="success"
                                  className="text-xs w-fit mx-auto"
                                >
                                  Sucesso
                                </Badge>
                              ) : (
                                <Badge
                                  color="failure"
                                  className="text-xs w-fit mx-auto"
                                >
                                  Falha
                                </Badge>
                              )}
                            </Table.Cell>
                            <Table.Cell className="text-center text-xs py-2">
                              {attempt.reason || "—"}
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </>
                    )}
                  </>
                ) : (
                  <TableLoading cols={5} />
                )}
              </Table.Body>
            </Table>
          </div>
          {totalCount > 0 && (
            <div className="mt-3 text-center text-sm">
              Foram encontrados {totalCount} registros no total
            </div>
          )}
          {totalPages > 1 && (
            <div className="flex overflow-x-auto justify-center mt-3">
              <Pagination
                layout="pagination"
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                previousLabel=""
                nextLabel=""
                showIcons
              />
            </div>
          )}
        </>
      ) : (
        <EmptyTable icon="search_off">
          Nenhum acesso encontrado neste período
        </EmptyTable>
      )}
    </>
  );
};

export default AdminLoginAttemptsTable;
